import { render } from "./HomeView.vue?vue&type=template&id=a580163e&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.scss?vue&type=style&index=0&id=a580163e&lang=scss&scoped=true"

import exportComponent from "/Users/lml/Code/threeman-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a580163e"]])

export default __exports__